export const DisplayTypesInCompaniesConstant = {
    LIST: 1,
    ADD: 2,
    EDIT:3,
    DELETE:4,
}
